<template>
  <div>
    <v-alert type="info" variant="tonal" :color="warningColor" class="warning-alert">
      <p class="password_warning">
        A senha deve ser diferente do nome de usuário e das últimas 12 senhas!
      </p>
    </v-alert>
    <v-card class="mx-auto" color="#E7E7E7" id="password-conditions" width="460px">
      <v-card-text>
        <p v-for="(condition, index) in conditions" :class="passwordParagraph(index)" :key="index">
          <v-icon class="material-icons md-18" color="#0FAC67" v-if="matchRegex(index)">
            mdi-check
          </v-icon>
          {{ condition }}
        </p>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: {
    password: {
      type: String
    },
    length: {
      type: Boolean
    }
  },
  data() {
    return {
      conditions: [
        'Deve ter pelo menos uma letra minúscula',
        'Deve ter pelo menos uma letra maiúscula',
        'Deve ter pelo menos um número',
        'Deve ter pelo menos um caractere especial',
        'Não deve possuir as palavras "senha", "mudar" e "password"',
        'Não deve possuir 3 caracteres sequenciais consecutivos iguais (ex: aaa, 222)',
        'Deve ter entre 8 e 12 caracteres'
      ],
      paragraphColor: 'password-not-checked'
    }
  },
  computed: {
    ...mapGetters(["isSerasa"]),
    isPasswordValid() {
      const regex = [
        /[a-z]/,
        /[A-Z]/,
        /[0-9]/,
        /[!@#$%^&*]/,
        /^(?!.*mudar)(?!.*senha)(?!.*password).*$/,
        /^(?!.*(.)\1\1)/,
        /^.{8,12}$/
      ]
      return regex.map((regex) => regex.test(this.password))
    },
    warningColor() {
      return this.isSerasa ? '#4B65EC' : '#42A5F5'
    }
  },
  methods: {
    matchRegex(index) {
      return this.isPasswordValid[index]
    },
    passwordParagraph(index) {
      return this.isPasswordValid[index] ? 'password-checked' : 'password-not-checked'
    }
  }
}
</script>
<style scoped>
.password-not-checked {
  color: var(--grayscale-lighten-2, #a4a6ac);
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  opacity: 1;
}
.password-checked {
  color: var(--grayscale-lighten-2, #0e0f0f);
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  opacity: 1;
}
#password-conditions {
  max-width: 350px;
  background-color: #a4a6ac;
  opacity: 1;
  margin-top: 4px;
}

.password_warning {
  text-align: justify;
  font-size: 12px;
}

.warning-alert {
  min-width: 22rem;
}
.material-icons.md-18 {
  font-size: 18px;
}
</style>
